import { render, staticRenderFns } from "./privacy2.vue?vue&type=template&id=d4bf7014&scoped=true"
import script from "./privacy2.vue?vue&type=script&lang=js"
export * from "./privacy2.vue?vue&type=script&lang=js"
import style0 from "./privacy2.vue?vue&type=style&index=0&id=d4bf7014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bf7014",
  null
  
)

export default component.exports